import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { UserOnboardErrorResponse } from '../../common/api/clients/userOnboard.api';
import { queries } from '../../common/api/queryKeys/queries';

export const useUserOnboarding = (userId: string, token: string) => {
    return useQuery({
        ...queries.members.onboarding(userId, token),
        staleTime: Infinity,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        throwOnError: false,
        retry: (failureCount, error: AxiosError<UserOnboardErrorResponse>) => {
            if (error.response?.status === 403) {
                return false;
            }

            return failureCount <= 3;
        },
    });
};
